import React, { useEffect, useState } from "react";
import { Route } from "polyrouter";
import { useTranslation } from "utilities/i18n";
import { HelpLink, PolyIcon, SupportLink } from "elements";
import "./AdminMenu.scss";
import { SupportLinkType, translationKeys } from "Constants";
import { trackMenuSelection } from "monitoring/trackMenuSelection";

export const SupportMenu: React.FC = () => {
  const [open, setOpen] = useState(false);
  const self = React.useRef<HTMLSpanElement>(null);
  const { t } = useTranslation();

  const closeMenu = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!self?.current?.contains(e.target as Node)) {
        closeMenu();
      }
    };

    document.addEventListener("mousedown", handleClick, false);

    return () => {
      document.removeEventListener("mousedown", handleClick, false);
    };
  }, []);

  const dropdownClasses = [
    "menu vertical close-quickly pl-0 font-sm text-left",
    open && "open"
  ]
    .filter(c => !!c)
    .join(" ");

  return (
    <span ref={self}>
      <nav>
        <Route
          render={({ location }) => (
            <span
              onClick={() => setOpen(!open)}
              className="support-icon icon-wrap"
              data-testid="support-trigger"
              role="button"
              aria-controls="menu"
              id="supportbutton"
              aria-haspopup="true"
              aria-label="Support menu"
              aria-expanded={open ? "true" : "false"}
            >
              <PolyIcon
                icon="life_ring"
                className={`white main-icon ${open ? "active" : ""}`}
                title={t("OPEN_SUPPORT")}
              />
            </span>
          )}
        />
        <ul
          className={dropdownClasses}
          aria-labelledby="menubutton"
          data-testid="support-dropdown"
          id="supportmenu"
        >
          <li
            onClick={() => {
              trackMenuSelection("Device Support");
              closeMenu();
            }}
          >
            <SupportLink
              text={translationKeys.DEVICES}
              type={SupportLinkType.DEVICES}
              icon="headset"
            />
          </li>
          <li
            onClick={() => {
              trackMenuSelection("Lens Help");
              closeMenu();
            }}
          >
            <HelpLink>
              <PolyIcon className="mr-5 white" icon="help_circle" />
              {t(translationKeys.LENS)}
            </HelpLink>
          </li>
        </ul>
      </nav>
    </span>
  );
};
